'use strict'

var push = require('./util/add.js')

module.exports = add

var NO_CODES = []

// Add `value` to the checker.
function add(value, model) {
  var self = this

  push(self.data, value, self.data[model] || NO_CODES, self)

  return self
}
